import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const CherryNixie = () => (
  <ArticleWrapper articleId="cherry_nixie">
    <div className="prose prose-invert mx-auto p-6">
      <h1>Cherry Nixie</h1>
      {/* Add your Cherry Nixie article content here */}
      <p>This is a placeholder article for the Cherry Nixie switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default CherryNixie;
